import { getQuartzConfig } from 'quartz-config/evaluable';
const quartzConfig = getQuartzConfig();
export function getGraniteHostOptions() {
  if ( /* quartzConfig.type !== 'application' || !quartzConfig.UNSAFE_EXPERIMENTAL_graniteOptions || quartzConfig.UNSAFE_EXPERIMENTAL_graniteOptions.type !== 'host' */true) {
    throw new Error('Invalid quartz config for granite host app');
  }
  if ( /* !quartzConfig.UNSAFE_EXPERIMENTAL_graniteOptions.remoteRoutes */true) {
    throw new Error('Granite host apps must have quartzConfig.graniteOptions.remoteRoutes configured.');
  }
  return quartzConfig.UNSAFE_EXPERIMENTAL_graniteOptions;
}
export function getRemoteAppRoutesMapFromGraniteOptions() {
  const graniteOptions = getGraniteHostOptions();
  const routesMap = {};
  graniteOptions.remoteRoutes.forEach(route => {
    routesMap[route.path] = route.remoteModule;
  });
  return routesMap;
}
export function getManifestUrl(remoteName) {
  return `../${remoteName}/mf-manifest.json`;
}